<template>
  <div>
    <div class="contain" v-show="alert == true">
      <p class="question">请确认提交</p>
      <div class="down">
        <button class="del" @click="cancel">取消</button>
        <button class="yes" @click="confirm">确认</button>
      </div>
    </div>
    <div class="contain" v-show="isOpen == true">
      <p class="question">提交成功</p>
      <div class="down">
        <button class="del" @click="unOpen">取消</button>
        <button class="yes" @click="unOpen">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    alert: {
      type: Boolean,
      default: "",
    },
    mformData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    unOpen() {
      this.isOpen = false;
    },
    cancel() {
      this.$emit("sonalert");
    },
    confirm() {
      window.localStorage.setItem("mformData", JSON.stringify(this.mformData));
      this.$emit("sonsubmitm");
      this.isOpen = true;
    },
    confirm() {
      if (this.mformData.name == '' || this.mformData.tel == '' || this.mformData.mail == ''|| this.mformData.company == ''|| this.mformData.details == '') {
        alert("请完善信息");
      }else{
        // console.log(this.mformData.name);
        // window.localStorage.setItem("formData", JSON.stringify(this.formData));
        // this.$emit("sonsubmit");
        this.$emit("sonalert");
        this.isOpen = true;
        const form = this.mformData;
        console.log(form);
        axios.post('mail.php',this.mformData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then((res) => {
          if(res.status != 200) {
            console.log('Internal Error！');
          }else {
            if (res.data.code == 0){
              console.log(res.data.message);
            }else if (res.data.code == 1){
              console.log(res.data.message);
            }
          }
        })
      } 
    },
  },
};
</script>

<style lang="less" scoped>
.contain {
  z-index: 99;
  width: 50rem;
  height: 30rem;
  background: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 1rem;
  border-radius: 1rem;
  border: 1px solid #0b3290;
  .question {
    text-align: center;
    margin-bottom: 4rem;
    font-size: 2.7rem;
    color: #0b3290;
  }
  .down {
    display: flex;
    width: 100%;
    justify-content: space-around;
    height: 20%;
  }
  .del,
  .yes {
    width: 40%;
    cursor: pointer;
    border: 1px solid #0b3290;
    font-size: 1.8rem;
    border-radius: 5px;
  }
  .yes {
    background: #0b3290;
    color: #fff;
  }
  .yes:hover {
    background: #fff;
    color: #0b3290;
  }
}
</style>